
import { Vue, Component, Ref, Watch } from 'vue-property-decorator';
import FollowUpModal from './components/FollowUpModal.vue';
import lazyInject from '@/di';
import CustomerFundingService from '@/services/customerFunding.service';
import moment from 'moment';
import FollowsListModal from './components/FollowsListModal.vue';
import UTILService from '@/services/utils.service';
import { AuthEnum } from '@/services/permission.service';
import VisitDetailListModal from './components/VisitDetailListModal.vue';

@Component({
  components: {
    FollowUpModal,
    FollowsListModal,
    VisitDetailListModal,
  },
})
export default class CustomerFunding extends Vue {
  @lazyInject(CustomerFundingService)
  private customerFundingService!: CustomerFundingService;

  @Ref('followUpModal')
  followUpModal!: FollowUpModal;

  @Ref('followsListModal')
  followsListModal!: FollowsListModal;

  @Ref('visitDetailListModal')
  visitDetailListModal!: VisitDetailListModal;

  @lazyInject(UTILService)
  utilService!: UTILService;

  AuthEnum = AuthEnum;
  form: any = {
    lead_id: '',
    status: undefined,
    ctime_start: '',
    ctime_end: '',
    phone: '',
    shop_name: '',
    poi: '',
    category: undefined,
    dept: undefined,
    group: undefined,
    agent: '',
    ad_id: '',
    ad_phone: '',
    compensation: '',

  };
  columns: any[] = [
    {
      title: '推广通代运营',
      dataIndex: 'agent_name',
      key: 'agent_name',
      align: 'center',
      width: 120,
    },
    {
      title: '广告主ID',
      dataIndex: 'advertiser_id',
      key: 'advertiser_id',
      align: 'center',
      width: 200,
    },
    {
      title: '客资电话',
      dataIndex: 'phone',
      key: 'phone',
      align: 'center',
      width: 180,
      scopedSlots: { customRender: 'phone' },
    },
    {
      title: '门店名称',
      dataIndex: 'shop_name',
      key: 'shop_name',
      align: 'center',
      width: 160,
    },
    {
      title: 'POI',
      dataIndex: 'poi',
      key: 'poi',
      align: 'center',
      width: 140,
    },
    {
      title: '广告主电话',
      dataIndex: 'ad_phone',
      key: 'ad_phone',
      align: 'center',
      width: 190,
      scopedSlots: { customRender: 'ad_phone' },
    },
    {
      title: '老板电话',
      dataIndex: 'boss_phone',
      key: 'boss_phone',
      align: 'center',
      width: 190,
      scopedSlots: { customRender: 'boss_phone' },
    },
    {
      title: '用户名',
      dataIndex: 'username',
      key: 'username',
      align: 'center',
      width: 100,
    },
    {
      title: '客资类型',
      dataIndex: 'category',
      key: 'category',
      align: 'center',
      width: 100,
    },
    {
      title: '获取时间',
      dataIndex: 'ctime',
      key: 'ctime',
      align: 'center',
      width: 180,
    },
    {
      title: '城市',
      dataIndex: 'city',
      key: 'city',
      align: 'center',
      width: 100,
    },
    // {
    //   title: '客户来源',
    //   dataIndex: 'customerSource',
    //   key: 'customerSource',
    //   align: 'center',
    // },
    {
      title: '客资状态',
      dataIndex: 'status_str',
      key: 'status_str',
      align: 'center',
      width: 100,
    },
    {
      title: '赔付状态',
      dataIndex: 'compensation',
      key: 'compensation',
      align: 'center',
      width: 100,
      customRender: (text: any) => {
        if (text === 0) {
          return '未赔付';
        } else if (text === 1) {
          return '赔付成功';
        } else if (text === 2) {
          return '赔付失败';
        } else if (text === 9) {
          return '--';
        } else {
          return '';
        }
      },
    },
    {
      title: 'leadId',
      dataIndex: 'lead_id',
      key: 'lead_id',
      align: 'center',
      width: 180,
    },
    {
      title: '跟进备注',
      dataIndex: 'last_follow_info',
      key: 'last_follow_info',
      align: 'center',
      width: 200,
    },
    {
      title: '操作',
      dataIndex: 'operation',
      key: 'operation',
      fixed: 'right',
      scopedSlots: { customRender: 'action' },
      align: 'center',
      width: 120,
    },
  ];
  data: any[] = [];
  ctime_arr: any[] = [];
  pagination = {
    pageSize: 10,
    current: 1,
    total: 0,
    onChange: this.handlePageChange,
  };

  deptList: any[] = [];

  groupList: any[] = [];

  activeKey = '1';
  all = '全部(100)';
  followUp = '跟进(100)';
  visit = '回访(100)';

  customerList: any[] = [];

  typeStare = '';


  statusList: any[] = [
    {
      value: 0,
      label: '待联系',
    },
    {
      value: 1,
      label: '待到店',
    },
    {
      value: 2,
      label: '已到店',
    },
    {
      value: 3,
      label: '已交易',
    },
    {
      value: 4,
      label: '未接通',
    },
    {
      value: 5,
      label: '无意向',
    },
  ];

  copmensList: any[] = [
    {
      value: '',
      label: '全部',
    },
    {
      value: 0,
      label: '未赔付',
    },
    {
      value: 1,
      label: '赔付成功',
    },
    {
      value: 2,
      label: '赔付失败',
    },
  ];

  @Watch('$route.query')
  onRouteChange() {
    const { dept, group, email, ad_id, ad_phone, shop_name, poi, lead_id, phone, ctime_start, ctime_end, category, agent, page, pageSize, status, compensation } = this.$route.query;
    const query: any = {
      page: page || 1,
      pageSize: pageSize || 10,
    };
    if (dept) {
      query.dept = dept;
      this.form.dept = +dept;
    }
    if (group) {
      query.group = group;
      this.form.group = +group;
    }
    if (email) {
      query.email = email;
      this.form.email = email;
    }
    if (ad_id) {
      query.ad_id = ad_id;
      this.form.ad_id = ad_id;
    }
    if (ad_phone) {
      query.ad_phone = ad_phone;
      this.form.ad_phone = ad_phone;
    }
    if (shop_name) {
      query.shop_name = shop_name;
      this.form.shop_name = shop_name;
    }
    if (poi) {
      query.poi = poi;
      this.form.poi = poi;
    }
    if (lead_id) {
      query.lead_id = lead_id;
      this.form.lead_id = lead_id;
    }
    if (phone) {
      query.phone = phone;
      this.form.phone = phone;
    }
    if (ctime_start && ctime_end) {
      query.ctime_start = ctime_start;
      query.ctime_end = ctime_end;
      this.form.ctime_start = ctime_start;
      this.form.ctime_end = ctime_end;
      this.ctime_arr = [moment(ctime_start as string), moment(ctime_end as string)];
    }
    if (agent) {
      query.agent = agent;
      this.form.agent = agent;
    }
    if (category) {
      query.category = category;
      this.form.category = category;
    }
    if (status !== undefined) {
      query.status = +status;
      this.form.status = +status;
    }
    if (compensation !== undefined) {
      query.compensation = compensation;
      this.form.compensation = compensation;
    }
    this.getCustomerFundingList(query);
  }

  search() {
    this.pagination.current = 1;
    this.getQuery();
  }

  getQuery() {
    const { dept, group, email, ad_id, ad_phone, shop_name, poi, lead_id, phone, ctime_start, ctime_end, category, agent, status, compensation } = this.form;
    const { current, pageSize } = this.pagination;
    const query: any = {
      page: current,
      pageSize,
    };
    if (dept) {
      query.dept = dept;
    }
    if (group) {
      query.group = group;
    }
    if (email) {
      query.email = email;
    }
    if (ad_id) {
      query.ad_id = ad_id;
    }
    if (ad_phone) {
      query.ad_phone = ad_phone;
    }
    if (shop_name) {
      query.shop_name = shop_name;
    }
    if (poi) {
      query.poi = poi;
    }
    if (lead_id) {
      query.lead_id = lead_id;
    }
    if (phone) {
      query.phone = phone;
    }
    if (ctime_start) {
      query.ctime_start = ctime_start;
    }
    if (ctime_end) {
      query.ctime_end = ctime_end;
    }
    if (category) {
      query.category = category;
    }
    if (agent) {
      query.agent = agent;
    }
    if (status !== undefined) {
      query.status = status;
    }
    if (compensation !== undefined) {
      query.compensation = compensation;
    }
    query.timestamp = `${Math.round(Date.now() / 1000)}`;
    this.$router.push({
      query,
    });
  }
  handlePageChange(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.getQuery();
  }
  onChangeCreateTime(date: any) {
    if (date && date.length) {
      this.form.ctime_start = moment(date[0]).format('YYYY-MM-DD');
      this.form.ctime_end = moment(date[1]).format('YYYY-MM-DD');
    } else {
      this.form.ctime_start = '';
      this.form.ctime_end = '';
    }
  }

  refresh() {
    // console.log('CustomerFunding refresh');
  }
  reset() {
    this.form = {
      dept: undefined,
      group: undefined,
      email: '',
      ad_id: '',
      ad_phone: '',
      shop_name: '',
      poi: '',
      lead_id: '',
      phone: '',
      ctime_start: '',
      ctime_end: '',
      category: undefined,
      agent: '',
      status: undefined,
      compensation: '',
    };
    this.ctime_arr = [];
    this.getQuery();
  }
  handleEdit(record: any) {
    this.followUpModal.init(record);
  }

  handleFollowsList(record: any) {
    this.followsListModal.init(record);
  }

  handleVisitDetailList(record: any) {
    this.visitDetailListModal.init(record);
  }

  mounted() {
    // console.log('CustomerFunding mounted');
    this.getDeptList();
    this.getCategoryList();
    this.onRouteChange();
  }


  async LookShopDetail(title: string, encryptAccount: string) {
    const data = {
      encrypt_phone: encryptAccount,
      operate_type: title,
    };
    try {
      const res = await this.utilService.postPhoneDecrypt(data);
      if (res) {
        this.$info({
          title,
          centered: true,
          content: res,
        });
      }
    } catch (error) {
      this.$message.error('解密失败');
    }
  }

  async getDeptList() {
    const response = await this.customerFundingService.getDeptList();
    this.deptList = response;
  }

  handleDeptChange(value: any) {
    this.deptList.forEach((item: any) => {
      const dept: any = item.dept.id;
      if (dept == value) {
        // console.log(item.group);
        this.groupList = item.group;
      }
    });
  }

  async getCustomerFundingList(params: any) {
    const response = await this.customerFundingService.getAgentList(params);
    // console.log('CustomerFunding mounted', response);
    this.data = response.list;
    this.pagination.total = response.total;
    this.pagination.current = response.page;
    this.pagination.pageSize = response.pageSize;
  }

  async getCategoryList() {
    const response = await this.customerFundingService.getCategoryList();
    const list: any = [];
    for (const item in response) {
      if (item) {
        list.push({
          value: item,
          label: response[item],
        });
      }
    }
    this.customerList = list;
  }
}
